import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import { useApiErrorHandler } from '../../../hooks/useApiErrorHandler'

import { DEALS_QUERY_KEY_ROOT } from './useDealsQuery'
import { dealQueryKey } from './useDealQuery'
import { shipmentsQueryKey } from './useShipmentsQuery'

interface DeleteVariables {
  dealId: string
  shipmentId: string
}

export function useDeleteShipmentMutation(): UseMutationResult<void, unknown, DeleteVariables> {
  const queryClient = useQueryClient()
  const handleError = useApiErrorHandler()

  return useMutation<void, unknown, DeleteVariables>(
    ({ dealId, shipmentId }) => dealsAPI.deleteShipment(dealId, shipmentId),
    {
      onSuccess: (_void, { dealId }) => {
        queryClient.invalidateQueries({ queryKey: DEALS_QUERY_KEY_ROOT })
        queryClient.invalidateQueries({ queryKey: shipmentsQueryKey(dealId) })
        queryClient.invalidateQueries({ queryKey: dealQueryKey(dealId) })
      },
      onError: handleError,
    },
  )
}
